import { render, staticRenderFns } from "./RuleConfigModify.vue?vue&type=template&id=12a52dea&scoped=true&"
import script from "./RuleConfigModify.vue?vue&type=script&lang=js&"
export * from "./RuleConfigModify.vue?vue&type=script&lang=js&"
import style0 from "./RuleConfigModify.vue?vue&type=style&index=0&id=12a52dea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a52dea",
  null
  
)

export default component.exports